/*----------------------------------------------------

	onload.js

----------------------------------------------------*/

var body = document.querySelector('.no-js');
body.classList.remove('no-js');
body.classList.add('js');

// to loop over a nodeList (i.e. the result of querySelectorAll)
var forEach = function(array, callback, scope) {
 for (var i = 0; i < array.length; i++) {
   callback.call(scope, i, array[i]); // passes back stuff we need
 }
};

// is visible
function isVisible(obj){
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}



// A. dynamic loading
// -----------------------------------------------------------------------------------

function loadScript(url){
  (function(document, tag) {
      var scriptTag = document.createElement(tag), // create a script tag
          firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
      scriptTag.src = url; // set the source of the script to your script
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
  }(document, 'script'));
}

function loadCSS(url){
  var head = document.getElementsByTagName('head')[0];
  var link  = document.createElement('link');
  link.rel  = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  head.appendChild(link);
}

// googlemaps
/*if(document.querySelectorAll('.map-canvas').length > 0){
  loadScript('/wp-content/themes/wobeckcranes-2017/inc/js/googlemaps.js');
}*/

loadScript('/inc/js/modal.js');

// lightbox - baguetteBox
if(document.querySelectorAll('.gallery').length > 0 || document.querySelectorAll('.lightbox').length > 0){
  loadScript('/inc/js/baguetteBox.js');
  loadCSS('/inc/css/plugins/baguetteBox.css');
}

// gallery - macy
if(document.querySelectorAll('.photo-gallery').length > 0){
  loadScript('/inc/js/macy.js');
}

// carousel
if(document.querySelectorAll('[data-scarousel]').length > 0){
  loadScript('/inc/js/scarousel.js');
}


// B. scroll to anchor
// -----------------------------------------------------------------------------------

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if(!isIE11){

  (function() {
  	bindScrollTo();
  })();

  function bindScrollTo(){
  	var links = document.querySelectorAll('.scroll-link');
  	//links.forEach(each => (each.onclick = scrollAnchors));

    [].forEach.call(links, function(each){
      each.addEventListener('click', scrollAnchors);
    });
  }

  function scrollAnchors(e){
    var respond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  	e.preventDefault();
  	var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
  	var targetAnchor = document.querySelector(targetID);
  	scrollTo(targetAnchor);
  }

  function distanceToTop(el){
    return Math.floor(el.getBoundingClientRect().top);
  }

  function scrollTo(targetAnchor){
    //var distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
    if (!targetAnchor) return;
    var originalTop = distanceToTop(targetAnchor);
    var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

    if(isSmoothScrollSupported){
      window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
    }else{
      window.scrollBy(0,originalTop);
    }

    var checkIfDone = setInterval(function() {
      var atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
      if (distanceToTop(targetAnchor) === 0 || atBottom) {
        targetAnchor.tabIndex = '-1';
        //targetAnchor.focus();
        //window.history.pushState('', '', targetID);
        clearInterval(checkIfDone);
      }
    }, 100);
  }

}


// C. external links in new tab
// -----------------------------------------------------------------------------------

var links = document.links;

for (var i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname != window.location.hostname || links[i].getAttribute('href').match('.pdf$')) {
    links[i].target = '_blank';
  }
}



// D. offcanvas navigation
// -----------------------------------------------------------------------------------

var offcanvas_open_link = document.querySelector('.nav-toggle');
var offcanvas_close_link = document.querySelector('.offcanvas__close');
var offcanvas_outer = document.querySelector('.offcanvas-outer');
var offcanvas_menu = document.querySelector('.offcanvas');


// open offcanvas
offcanvas_open_link.addEventListener('click', function(ev){

  ev.preventDefault();
  ev.stopPropagation();

  offcanvas_outer.style.display = 'block';
  offcanvas_outer.classList.remove('fade-out');
  offcanvas_outer.classList.add('fade-in'); // relying on support for css keyframe animation

  start_left = -Math.abs(parseInt(getComputedStyle(offcanvas_menu).width));
  end = 0;
  animateRight();

});


// close offcanvas
function closeOffcanvas(ev){

  // animate menu
  end = start_left;
  animateLeft();

  // fade out background
  offcanvas_outer.classList.remove('fade-in');
  offcanvas_outer.classList.add('fade-out');
  setTimeout(function(){
    offcanvas_outer.setAttribute('style','');
  }, 500)

}


// things that close offcanvas
// close button
offcanvas_close_link.addEventListener('click', function(ev){

	ev.preventDefault();
	ev.stopPropagation();

	closeOffcanvas();

});


// outside offcanvas
document.addEventListener('click', function(ev){
  if(isVisible(offcanvas_menu) && isVisible(offcanvas_open_link) && ev.target !== offcanvas_menu && !offcanvas_menu.contains(ev.target)){
		closeOffcanvas();
	}
});


// menu link - can't quite figure out in what instance this runs
/*offcanvas_menu.querySelectorAll('a').addEventListener('click', function(ev){
  if(!this.classList.contains('has-children')){
    if(isVisible(offcanvas_open_link) && ev.target !== offcanvas_menu && !offcanvas_menu.contains(ev.target)){
      closeOffcanvas();
    }
  }
});*/


// used to slide menu in
function animateRight(){
  var cur = parseInt(window.getComputedStyle(offcanvas_menu).left);
  if(isNaN(cur)){
    cur = -Math.abs(parseInt(getComputedStyle(offcanvas_menu).width)); // for iOS that won't get left on initial run
  }
  setTimeout(function(){
    if(cur < end){
      to_move = cur + 8 + 'px';
      to_move = (parseInt(to_move) > 0) ? '0px' : to_move; // ensure menu doesn't go above 0
      offcanvas_menu.style.left = to_move;
      animateRight();
    }
  }, 5);
}

// used to slide menu out
function animateLeft(){
  var cur = parseInt(getComputedStyle(offcanvas_menu).left);
  setTimeout(function(){
    if(cur > end){
      offcanvas_menu.style.left = cur - 8 + 'px';
      animateLeft();
    }
  }, 5);
}





// E. JS / bubble links
// -----------------------------------------------------------------------------------

(function(){

  'use strict';

  // Feature Test
  if('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach){

    var bubbleLink = document.querySelectorAll('.js-link');
    [].forEach.call(bubbleLink, function(bubble){

      bubble.addEventListener('click', function(e){

        e.preventDefault();

        var destination = bubble.querySelector('a:first-of-type').getAttribute('href');
        if(destination){
          if(e.ctrlKey || bubble.getAttribute('target') == '_blank' || bubble.querySelector('a:first-of-type').classList.contains('externalLink')){
    				window.open(destination,'_blank')
    			}else{
    				window.location.href = destination;
    			}
        }

      }, false);

    });

  }

})();




// F. product carousel
// -----------------------------------------------------------------------------------

var transition = 700;
var cards = document.querySelector('.cards');

if(cards){

  document.querySelector('.cards').classList.add('cards--carousel');
  document.querySelector('.cards-container').classList.add('cards-container--carousel');


  function cardButtonClick(e){
      e.preventDefault();
      var direction = this.getAttribute('data-dir');
      moveCards(direction);
  }


  function bindCardButtons(){
      var btns = document.querySelector('.cards__nav').querySelectorAll('button');

      [].forEach.call(btns, function(item){
          item.addEventListener('click', cardButtonClick);
          item.classList.add('can-click');
      });
  }
  bindCardButtons();


  function moveCards(direction){

      var btns = document.querySelector('.cards__nav').querySelectorAll('button');
      [].forEach.call(btns, function(item){
          item.removeEventListener('click',cardButtonClick);
          item.classList.remove('can-click');
      });

      var first_card = document.querySelector('.cards__item:first-child');
      var last_card = document.querySelector('.cards__item:last-child');
      var cards_container = document.querySelector('.cards');

      if(direction == 'next'){

          first_card.classList.add('first-item-move');
          cards_container.classList.add('in-motion');

          setTimeout(function(){

              first_card.classList.add('fade-in');
              first_card.parentNode.appendChild(first_card);
              first_card.classList.remove('first-item-move');
              cards_container.classList.remove('in-motion');

              setTimeout(function(){
                  first_card.classList.remove('fade-in');
                  bindCardButtons();
              },200);

          },transition);

      }

      if(direction == 'prev'){

          last_card.classList.add('last-item-move');
          last_card.parentNode.insertBefore(last_card,first_card);
          cards_container.classList.add('in-motion-reverse');

          setTimeout(function(){
              last_card.classList.remove('last-item-move');
              cards_container.classList.remove('in-motion-reverse');
              bindCardButtons();
          },transition);

      }

  }

}


// G. index tabs / accordian
// -----------------------------------------------------------------------------------

var tabs = document.querySelectorAll('.tabs');

if(tabs.length > 0){

  [].forEach.call(tabs, function(tab_group){

    if(window.matchMedia("(max-width:959px)").matches){
      var tab_version = 'accordian';
      buildAccordian(tab_group);
    }else{
      var tab_version = 'tabs';
      buildTabs(tab_group);
    }

  });

}

function buildAccordian(group){

  group.classList.remove('tabs');
  group.classList.add('accordian');

  var sections = group.querySelectorAll('section');
  var first = false;

  [].forEach.call(sections, function(section){

    //hide all but first
    if(Array.prototype.indexOf.call(section.parentNode.children, section) > 0){
      section.style.display = 'none';
      first = false;
    }else{
      first = true;
    }

    // create accordian links
    var section_link = document.createElement("a");
    section_link.setAttribute('href','#' + section.getAttribute('id'));
    if(first){
      section_link.setAttribute('class','accordian__link current');
    }else{
      section_link.setAttribute('class','accordian__link');
    }
    section_link.innerHTML = section.getAttribute('data-tab');
    section.parentNode.insertBefore(section_link, section);

  });

  // bind click to links
  var links = group.querySelectorAll('.accordian__link');
  toggleGroupShowHide(links,sections,group);

}



function buildTabs(group){

  var sections = group.querySelectorAll('section');
  var nav = '';
  var first = false;

  [].forEach.call(sections, function(section){

    //hide all but first
    if(Array.prototype.indexOf.call(section.parentNode.children, section) > 0){
      section.style.display = 'none';
      first = false;
    }else{
      first = true;
    }

    // create tab links
    if(first){
      nav = nav + '<li><a href="#' + section.getAttribute('id') + '" class="tabs__nav__link current">' + section.getAttribute('data-tab') + '</a></li>'
    }else{
      nav = nav + '<li><a href="#' + section.getAttribute('id') + '" class="tabs__nav__link">' + section.getAttribute('data-tab') + '</a></li>'
    }

  });

  // create tab nav wrapper
  var section_nav = document.createElement("nav");
  section_nav.setAttribute('class','tabs__nav');
  section_nav.innerHTML = '<ul>' + nav + '</ul>';
  group.insertBefore(section_nav, group.childNodes[0]);

  // bind click to links
  var links = group.querySelectorAll('.tabs__nav__link');
  toggleGroupShowHide(links,sections,group);

}

function toggleGroupShowHide(links,sections,group){

  [].forEach.call(links, function(link){
    link.addEventListener('click', function(e){

      e.preventDefault();
      elm = link.getAttribute('href');

      [].forEach.call(sections, function(section){
        section.style.display = 'none';
      });

      group.querySelector(elm).style.display = '';

      var curr = group.querySelector('.current');
      curr.classList.remove('current');
      link.classList.add('current');

    });
  });

}



// H. generic showhide
// -----------------------------------------------------------------------------------

var showhide_links = document.querySelectorAll('[data-showhide]');

// For each smooth scroll link
[].forEach.call(showhide_links, function(link){

  link.addEventListener('click', function(ev){

    // Prevent the default link behavior
    ev.preventDefault();
    ev.stopPropagation();

    var target = document.querySelector(link.getAttribute('href'));

    if(isVisible(target)){
      target.style.display = 'none';
      target.removeAttribute('style');
    }else{
      closeShowHide(ev);
      target.style.display = 'block';

      var child_links = target.querySelectorAll('a');
      [].forEach.call(child_links, function(cl){
        cl.addEventListener('click', function(ev){
          closeShowHide(target);
        });
      });

    }

  });

});


function closeShowHide(ev){
  var docclose = document.querySelectorAll('[data-docclose]');

  [].forEach.call(docclose, function(link){
    if(isVisible(link) && ev.target !== link && !link.contains(ev.target)){
      link.style.display = 'none';
      link.removeAttribute('style');
    }
  });
}

document.addEventListener('click', function(ev){
  closeShowHide(ev);
});



// I. Configurator AJAX
// -----------------------------------------------------------------------------------

function bindConfiguratorButton(){

  var btns = document.querySelectorAll('.proconf__fgroup [class^="btn"]:not(.no-ajax)');

  [].forEach.call(btns, function(btn){
    btn.addEventListener('click', function(ev){
      ev.preventDefault();
      if(btn.innerHTML == 'Reset'){
        nextConfiguratorStep(true);
      }else{
        nextConfiguratorStep();
      }
    });
  });

}
bindConfiguratorButton();


function nextConfiguratorStep(){

  var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var configurator = document.querySelector('.product__configurator');
  var form = configurator.querySelector('form');
  var destination = form.getAttribute('action');

  if(!reset){
    var formData = serialize(form);
  }

  var xhr  = new XMLHttpRequest()
  xhr.onreadystatechange = function(){
    if(xhr.readyState == XMLHttpRequest.DONE){
      if(xhr.status == 200){

        var data = xhr.responseText;

        tempDiv = document.createElement('div');
        tempDiv.innerHTML = data;

        configurator.innerHTML = tempDiv.querySelector('.product__configurator').innerHTML;

        scrollTo(configurator);

        bindConfiguratorButton();
        bindTooltipLink();

        baguetteBox.run('.lightbox');

      }
    }
  }

  xhr.open('POST', destination);
  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhr.send(formData);

}



// J. Tooltip Lightbox
// -----------------------------------------------------------------------------------

function bindTooltipLink(){

  var links = document.querySelectorAll('.tooltip');

  [].forEach.call(links, function(link){
    link.addEventListener('click', function(ev){
      ev.preventDefault();
      var href = link.getAttribute('href');
      openTooltipIframe(href);
    });
  });

}
bindTooltipLink();

function bindTooltipCloseLink(){

  var links = document.querySelectorAll('.tooltip-bkg, .tooltip__close');

  [].forEach.call(links, function(link){
    link.addEventListener('click', function(ev){
      ev.preventDefault();
      var tooltip = document.querySelector('.tooltip-bkg');
      tooltip.parentNode.removeChild(tooltip);
    });
  });

  var stop = document.querySelector('.tooltip-bkg').children;

  [].forEach.call(stop, function(link){
    link.addEventListener('click', function(ev){
      ev.stopPropagation();
    });
  });

}

function openTooltipIframe(href){

  var xhr  = new XMLHttpRequest()
  xhr.onreadystatechange = function(){
    if(xhr.readyState == XMLHttpRequest.DONE){
      if(xhr.status == 200){

        var data = xhr.responseText;

        var close_icon = '<svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="#FFF" d="M7.8 7l6-6c.2-.2.2-.6 0-.8s-.6-.2-.8 0l-6 6-6-6C.8 0 .4 0 .2.2S0 .8.2 1l6 6-6 6c-.2.2-.2.6 0 .8.1.1.2.2.4.2s.3-.1.4-.2l6-6 6 6c.1.1.3.2.4.2.1 0 .3-.1.4-.2.2-.2.2-.6 0-.8l-6-6z"/></svg>';

        new_html = document.createElement('div');
        new_html.classList.add('tooltip-bkg');
        new_html.innerHTML = '<div class="tooltip-inner">' + data + '</div> <a href="#" class="tooltip__close">' + close_icon + ' <span class="screen-reader-text">Close</span></a>';

        document.querySelector('body').appendChild(new_html);

        bindTooltipCloseLink();

      }
    }
  }

  xhr.open('GET', href);
  xhr.send();

}



// K. Form Extras
// -----------------------------------------------------------------------------------

var survey_diff_address = document.querySelectorAll('.form__diff_address');
if(survey_diff_address.length > 0){

  var survey_site_address = document.querySelector('.form__site_address');
  survey_site_address.style.display = 'none';

  var inputs = document.querySelectorAll('.form__diff_address input');

  [].forEach.call(inputs, function(input){
    input.addEventListener('change', function(ev){
      var val = input.value;
      if(val == 'Yes'){
        survey_site_address.style.display = 'block';
      }else{
        survey_site_address.style.display = 'none';
      }
    });
  });

}





/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
*/
var serialize = function (form) {

	// Setup our serialized data
	var serialized = [];

	// Loop through each field in the form
	for (var i = 0; i < form.elements.length; i++) {

		var field = form.elements[i];

		// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
		if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

		// If a multi-select, get all selections
		if (field.type === 'select-multiple') {
			for (var n = 0; n < field.options.length; n++) {
				if (!field.options[n].selected) continue;
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
			}
		}

		// Convert field data to a query string
		else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
			serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
		}
	}

	return serialized.join('&');

};



// progressive-image.js, v1.1
// by Craig Buckler, @craigbuckler
window.addEventListener&&window.requestAnimationFrame&&document.getElementsByClassName&&window.addEventListener("load",function(){function e(){i=i||setTimeout(function(){i=null,t()},300)}function t(){r.length&&requestAnimationFrame(function(){for(var e,t,i,s=window.pageYOffset,o=s+window.innerHeight,d=0;d<r.length;)e=r[d].getBoundingClientRect(),t=s+e.top,i=t+e.height,i>s&&o>t?(n(r[d]),r[d].classList.remove("replace")):d++;a=r.length})}function n(e){function t(){requestAnimationFrame(function(){n===e.href&&(e.style.cursor="default",e.addEventListener("click",function(e){e.preventDefault()},!1)),e.appendChild(a).addEventListener("animationend",function(t){var n=e.querySelector&&e.querySelector("img.preview");n&&(t.target.alt=n.alt||"",e.removeChild(n),t.target.classList.remove("reveal"))})})}var n=e&&(e.getAttribute("data-href")||e.href);if(n){var a=new Image;e.dataset&&(a.srcset=e.dataset.srcset||"",a.sizes=e.dataset.sizes||""),a.src=n,a.className="reveal",a.complete?t():a.onload=t}}var a,i,r=document.getElementsByClassName("progressive replace");if(window.addEventListener("scroll",e,!1),window.addEventListener("resize",e,!1),MutationObserver){var s=new MutationObserver(function(){r.length!==a&&t()});s.observe(document.body,{subtree:!0,childList:!0,attributes:!0,characterData:!0})}t()},!1);

/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
!function(a){var b=navigator.userAgent;a.HTMLPictureElement&&/ecko/.test(b)&&b.match(/rv\:(\d+)/)&&RegExp.$1<45&&addEventListener("resize",function(){var b,c=document.createElement("source"),d=function(a){var b,d,e=a.parentNode;"PICTURE"===e.nodeName.toUpperCase()?(b=c.cloneNode(),e.insertBefore(b,e.firstElementChild),setTimeout(function(){e.removeChild(b)})):(!a._pfLastSize||a.offsetWidth>a._pfLastSize)&&(a._pfLastSize=a.offsetWidth,d=a.sizes,a.sizes+=",100vw",setTimeout(function(){a.sizes=d}))},e=function(){var a,b=document.querySelectorAll("picture > img, img[srcset][sizes]");for(a=0;a<b.length;a++)d(b[a])},f=function(){clearTimeout(b),b=setTimeout(e,99)},g=a.matchMedia&&matchMedia("(orientation: landscape)"),h=function(){f(),g&&g.addListener&&g.addListener(f)};return c.srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",/^[c|i]|d$/.test(document.readyState||"")?h():document.addEventListener("DOMContentLoaded",h),f}())}(window),function(a,b,c){"use strict";function d(a){return" "===a||"	"===a||"\n"===a||"\f"===a||"\r"===a}function e(b,c){var d=new a.Image;return d.onerror=function(){A[b]=!1,ba()},d.onload=function(){A[b]=1===d.width,ba()},d.src=c,"pending"}function f(){M=!1,P=a.devicePixelRatio,N={},O={},s.DPR=P||1,Q.width=Math.max(a.innerWidth||0,z.clientWidth),Q.height=Math.max(a.innerHeight||0,z.clientHeight),Q.vw=Q.width/100,Q.vh=Q.height/100,r=[Q.height,Q.width,P].join("-"),Q.em=s.getEmValue(),Q.rem=Q.em}function g(a,b,c,d){var e,f,g,h;return"saveData"===B.algorithm?a>2.7?h=c+1:(f=b-c,e=Math.pow(a-.6,1.5),g=f*e,d&&(g+=.1*e),h=a+g):h=c>1?Math.sqrt(a*b):a,h>c}function h(a){var b,c=s.getSet(a),d=!1;"pending"!==c&&(d=r,c&&(b=s.setRes(c),s.applySetCandidate(b,a))),a[s.ns].evaled=d}function i(a,b){return a.res-b.res}function j(a,b,c){var d;return!c&&b&&(c=a[s.ns].sets,c=c&&c[c.length-1]),d=k(b,c),d&&(b=s.makeUrl(b),a[s.ns].curSrc=b,a[s.ns].curCan=d,d.res||aa(d,d.set.sizes)),d}function k(a,b){var c,d,e;if(a&&b)for(e=s.parseSet(b),a=s.makeUrl(a),c=0;c<e.length;c++)if(a===s.makeUrl(e[c].url)){d=e[c];break}return d}function l(a,b){var c,d,e,f,g=a.getElementsByTagName("source");for(c=0,d=g.length;d>c;c++)e=g[c],e[s.ns]=!0,f=e.getAttribute("srcset"),f&&b.push({srcset:f,media:e.getAttribute("media"),type:e.getAttribute("type"),sizes:e.getAttribute("sizes")})}function m(a,b){function c(b){var c,d=b.exec(a.substring(m));return d?(c=d[0],m+=c.length,c):void 0}function e(){var a,c,d,e,f,i,j,k,l,m=!1,o={};for(e=0;e<h.length;e++)f=h[e],i=f[f.length-1],j=f.substring(0,f.length-1),k=parseInt(j,10),l=parseFloat(j),X.test(j)&&"w"===i?((a||c)&&(m=!0),0===k?m=!0:a=k):Y.test(j)&&"x"===i?((a||c||d)&&(m=!0),0>l?m=!0:c=l):X.test(j)&&"h"===i?((d||c)&&(m=!0),0===k?m=!0:d=k):m=!0;m||(o.url=g,a&&(o.w=a),c&&(o.d=c),d&&(o.h=d),d||c||a||(o.d=1),1===o.d&&(b.has1x=!0),o.set=b,n.push(o))}function f(){for(c(T),i="",j="in descriptor";;){if(k=a.charAt(m),"in descriptor"===j)if(d(k))i&&(h.push(i),i="",j="after descriptor");else{if(","===k)return m+=1,i&&h.push(i),void e();if("("===k)i+=k,j="in parens";else{if(""===k)return i&&h.push(i),void e();i+=k}}else if("in parens"===j)if(")"===k)i+=k,j="in descriptor";else{if(""===k)return h.push(i),void e();i+=k}else if("after descriptor"===j)if(d(k));else{if(""===k)return void e();j="in descriptor",m-=1}m+=1}}for(var g,h,i,j,k,l=a.length,m=0,n=[];;){if(c(U),m>=l)return n;g=c(V),h=[],","===g.slice(-1)?(g=g.replace(W,""),e()):f()}}function n(a){function b(a){function b(){f&&(g.push(f),f="")}function c(){g[0]&&(h.push(g),g=[])}for(var e,f="",g=[],h=[],i=0,j=0,k=!1;;){if(e=a.charAt(j),""===e)return b(),c(),h;if(k){if("*"===e&&"/"===a[j+1]){k=!1,j+=2,b();continue}j+=1}else{if(d(e)){if(a.charAt(j-1)&&d(a.charAt(j-1))||!f){j+=1;continue}if(0===i){b(),j+=1;continue}e=" "}else if("("===e)i+=1;else if(")"===e)i-=1;else{if(","===e){b(),c(),j+=1;continue}if("/"===e&&"*"===a.charAt(j+1)){k=!0,j+=2;continue}}f+=e,j+=1}}}function c(a){return k.test(a)&&parseFloat(a)>=0?!0:l.test(a)?!0:"0"===a||"-0"===a||"+0"===a?!0:!1}var e,f,g,h,i,j,k=/^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,l=/^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;for(f=b(a),g=f.length,e=0;g>e;e++)if(h=f[e],i=h[h.length-1],c(i)){if(j=i,h.pop(),0===h.length)return j;if(h=h.join(" "),s.matchesMedia(h))return j}return"100vw"}b.createElement("picture");var o,p,q,r,s={},t=!1,u=function(){},v=b.createElement("img"),w=v.getAttribute,x=v.setAttribute,y=v.removeAttribute,z=b.documentElement,A={},B={algorithm:""},C="data-pfsrc",D=C+"set",E=navigator.userAgent,F=/rident/.test(E)||/ecko/.test(E)&&E.match(/rv\:(\d+)/)&&RegExp.$1>35,G="currentSrc",H=/\s+\+?\d+(e\d+)?w/,I=/(\([^)]+\))?\s*(.+)/,J=a.picturefillCFG,K="position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)",L="font-size:100%!important;",M=!0,N={},O={},P=a.devicePixelRatio,Q={px:1,"in":96},R=b.createElement("a"),S=!1,T=/^[ \t\n\r\u000c]+/,U=/^[, \t\n\r\u000c]+/,V=/^[^ \t\n\r\u000c]+/,W=/[,]+$/,X=/^\d+$/,Y=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,Z=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d||!1):a.attachEvent&&a.attachEvent("on"+b,c)},$=function(a){var b={};return function(c){return c in b||(b[c]=a(c)),b[c]}},_=function(){var a=/^([\d\.]+)(em|vw|px)$/,b=function(){for(var a=arguments,b=0,c=a[0];++b in a;)c=c.replace(a[b],a[++b]);return c},c=$(function(a){return"return "+b((a||"").toLowerCase(),/\band\b/g,"&&",/,/g,"||",/min-([a-z-\s]+):/g,"e.$1>=",/max-([a-z-\s]+):/g,"e.$1<=",/calc([^)]+)/g,"($1)",/(\d+[\.]*[\d]*)([a-z]+)/g,"($1 * e.$2)",/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,"")+";"});return function(b,d){var e;if(!(b in N))if(N[b]=!1,d&&(e=b.match(a)))N[b]=e[1]*Q[e[2]];else try{N[b]=new Function("e",c(b))(Q)}catch(f){}return N[b]}}(),aa=function(a,b){return a.w?(a.cWidth=s.calcListLength(b||"100vw"),a.res=a.w/a.cWidth):a.res=a.d,a},ba=function(a){if(t){var c,d,e,f=a||{};if(f.elements&&1===f.elements.nodeType&&("IMG"===f.elements.nodeName.toUpperCase()?f.elements=[f.elements]:(f.context=f.elements,f.elements=null)),c=f.elements||s.qsa(f.context||b,f.reevaluate||f.reselect?s.sel:s.selShort),e=c.length){for(s.setupRun(f),S=!0,d=0;e>d;d++)s.fillImg(c[d],f);s.teardownRun(f)}}};o=a.console&&console.warn?function(a){console.warn(a)}:u,G in v||(G="src"),A["image/jpeg"]=!0,A["image/gif"]=!0,A["image/png"]=!0,A["image/svg+xml"]=b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"),s.ns=("pf"+(new Date).getTime()).substr(0,9),s.supSrcset="srcset"in v,s.supSizes="sizes"in v,s.supPicture=!!a.HTMLPictureElement,s.supSrcset&&s.supPicture&&!s.supSizes&&!function(a){v.srcset="data:,a",a.src="data:,a",s.supSrcset=v.complete===a.complete,s.supPicture=s.supSrcset&&s.supPicture}(b.createElement("img")),s.supSrcset&&!s.supSizes?!function(){var a="data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==",c="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",d=b.createElement("img"),e=function(){var a=d.width;2===a&&(s.supSizes=!0),q=s.supSrcset&&!s.supSizes,t=!0,setTimeout(ba)};d.onload=e,d.onerror=e,d.setAttribute("sizes","9px"),d.srcset=c+" 1w,"+a+" 9w",d.src=c}():t=!0,s.selShort="picture>img,img[srcset]",s.sel=s.selShort,s.cfg=B,s.DPR=P||1,s.u=Q,s.types=A,s.setSize=u,s.makeUrl=$(function(a){return R.href=a,R.href}),s.qsa=function(a,b){return"querySelector"in a?a.querySelectorAll(b):[]},s.matchesMedia=function(){return a.matchMedia&&(matchMedia("(min-width: 0.1em)")||{}).matches?s.matchesMedia=function(a){return!a||matchMedia(a).matches}:s.matchesMedia=s.mMQ,s.matchesMedia.apply(this,arguments)},s.mMQ=function(a){return a?_(a):!0},s.calcLength=function(a){var b=_(a,!0)||!1;return 0>b&&(b=!1),b},s.supportsType=function(a){return a?A[a]:!0},s.parseSize=$(function(a){var b=(a||"").match(I);return{media:b&&b[1],length:b&&b[2]}}),s.parseSet=function(a){return a.cands||(a.cands=m(a.srcset,a)),a.cands},s.getEmValue=function(){var a;if(!p&&(a=b.body)){var c=b.createElement("div"),d=z.style.cssText,e=a.style.cssText;c.style.cssText=K,z.style.cssText=L,a.style.cssText=L,a.appendChild(c),p=c.offsetWidth,a.removeChild(c),p=parseFloat(p,10),z.style.cssText=d,a.style.cssText=e}return p||16},s.calcListLength=function(a){if(!(a in O)||B.uT){var b=s.calcLength(n(a));O[a]=b?b:Q.width}return O[a]},s.setRes=function(a){var b;if(a){b=s.parseSet(a);for(var c=0,d=b.length;d>c;c++)aa(b[c],a.sizes)}return b},s.setRes.res=aa,s.applySetCandidate=function(a,b){if(a.length){var c,d,e,f,h,k,l,m,n,o=b[s.ns],p=s.DPR;if(k=o.curSrc||b[G],l=o.curCan||j(b,k,a[0].set),l&&l.set===a[0].set&&(n=F&&!b.complete&&l.res-.1>p,n||(l.cached=!0,l.res>=p&&(h=l))),!h)for(a.sort(i),f=a.length,h=a[f-1],d=0;f>d;d++)if(c=a[d],c.res>=p){e=d-1,h=a[e]&&(n||k!==s.makeUrl(c.url))&&g(a[e].res,c.res,p,a[e].cached)?a[e]:c;break}h&&(m=s.makeUrl(h.url),o.curSrc=m,o.curCan=h,m!==k&&s.setSrc(b,h),s.setSize(b))}},s.setSrc=function(a,b){var c;a.src=b.url,"image/svg+xml"===b.set.type&&(c=a.style.width,a.style.width=a.offsetWidth+1+"px",a.offsetWidth+1&&(a.style.width=c))},s.getSet=function(a){var b,c,d,e=!1,f=a[s.ns].sets;for(b=0;b<f.length&&!e;b++)if(c=f[b],c.srcset&&s.matchesMedia(c.media)&&(d=s.supportsType(c.type))){"pending"===d&&(c=d),e=c;break}return e},s.parseSets=function(a,b,d){var e,f,g,h,i=b&&"PICTURE"===b.nodeName.toUpperCase(),j=a[s.ns];(j.src===c||d.src)&&(j.src=w.call(a,"src"),j.src?x.call(a,C,j.src):y.call(a,C)),(j.srcset===c||d.srcset||!s.supSrcset||a.srcset)&&(e=w.call(a,"srcset"),j.srcset=e,h=!0),j.sets=[],i&&(j.pic=!0,l(b,j.sets)),j.srcset?(f={srcset:j.srcset,sizes:w.call(a,"sizes")},j.sets.push(f),g=(q||j.src)&&H.test(j.srcset||""),g||!j.src||k(j.src,f)||f.has1x||(f.srcset+=", "+j.src,f.cands.push({url:j.src,d:1,set:f}))):j.src&&j.sets.push({srcset:j.src,sizes:null}),j.curCan=null,j.curSrc=c,j.supported=!(i||f&&!s.supSrcset||g&&!s.supSizes),h&&s.supSrcset&&!j.supported&&(e?(x.call(a,D,e),a.srcset=""):y.call(a,D)),j.supported&&!j.srcset&&(!j.src&&a.src||a.src!==s.makeUrl(j.src))&&(null===j.src?a.removeAttribute("src"):a.src=j.src),j.parsed=!0},s.fillImg=function(a,b){var c,d=b.reselect||b.reevaluate;a[s.ns]||(a[s.ns]={}),c=a[s.ns],(d||c.evaled!==r)&&((!c.parsed||b.reevaluate)&&s.parseSets(a,a.parentNode,b),c.supported?c.evaled=r:h(a))},s.setupRun=function(){(!S||M||P!==a.devicePixelRatio)&&f()},s.supPicture?(ba=u,s.fillImg=u):!function(){var c,d=a.attachEvent?/d$|^c/:/d$|^c|^i/,e=function(){var a=b.readyState||"";f=setTimeout(e,"loading"===a?200:999),b.body&&(s.fillImgs(),c=c||d.test(a),c&&clearTimeout(f))},f=setTimeout(e,b.body?9:99),g=function(a,b){var c,d,e=function(){var f=new Date-d;b>f?c=setTimeout(e,b-f):(c=null,a())};return function(){d=new Date,c||(c=setTimeout(e,b))}},h=z.clientHeight,i=function(){M=Math.max(a.innerWidth||0,z.clientWidth)!==Q.width||z.clientHeight!==h,h=z.clientHeight,M&&s.fillImgs()};Z(a,"resize",g(i,99)),Z(b,"readystatechange",e)}(),s.picturefill=ba,s.fillImgs=ba,s.teardownRun=u,ba._=s,a.picturefillCFG={pf:s,push:function(a){var b=a.shift();"function"==typeof s[b]?s[b].apply(s,a):(B[b]=a[0],S&&s.fillImgs({reselect:!0}))}};for(;J&&J.length;)a.picturefillCFG.push(J.shift());a.picturefill=ba,"object"==typeof module&&"object"==typeof module.exports?module.exports=ba:"function"==typeof define&&define.amd&&define("picturefill",function(){return ba}),s.supPicture||(A["image/webp"]=e("image/webp","data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="))}(window,document);
